import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'

export const GraphDateRangeStyles = StyleSheet.create({
	container: {
		marginVertical: ThemedValues.marginVertical,
	},
	picker: {
		alignItems: 'center',
		justifyContent: "center",
	}
})